import { Flex, Tab, Tabs, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { TabBadge } from '../../../TabBadge';

export type TInviteTab = 'favorites' | 'worked_with' | 'new_to_you';

export interface ITabConfig {
  value: TInviteTab;
  label: string;
  count: number;
  testId: string;
}

interface ITabHeaderProps {
  activeTab: TInviteTab;
  onTabChange: (tab: TInviteTab) => void;
  tabs: ITabConfig[];
  allSelected: boolean;
  onToggleSelectAll: () => void;
  selectAllVisible: boolean;
}

export const TabHeader = ({
  activeTab,
  onTabChange,
  tabs,
  allSelected,
  onToggleSelectAll,
  selectAllVisible,
}: ITabHeaderProps) => (
  <Tabs
    defaultValue={activeTab}
    value={activeTab}
    onChange={(value) => onTabChange(value as TInviteTab)}
  >
    <Flex
      direction="row"
      align="center"
      justify="between"
      data-testid="invite-tab-header"
      style={{ padding: '0px 16px 0 0' }}
    >
      <div style={{ display: 'flex', gap: 12 }}>
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            data-testid={tab.testId}
            data-cy={tab.testId}
            label={
              <>
                {tab.label} <TabBadge count={tab.count} />
              </>
            }
          />
        ))}
      </div>

      {selectAllVisible && (
        <Typography
          as="span"
          bold
          variant="body1"
          color={colors.secondary[500]}
          data-testid="invite-select-all"
          data-cy="invite-select-all"
          onClick={onToggleSelectAll}
          style={{ cursor: 'pointer', paddingBottom: 8 }}
        >
          {allSelected ? 'Unselect All' : 'Select All'}
        </Typography>
      )}
    </Flex>
  </Tabs>
);
